
import { Button, FormControl } from '@mui/material'
import { UploadCloud, XCircle } from 'react-feather'

// Imports custom
import { FileManagerInput } from 'common'

const acceptConfiguration = {
    'application/pdf': []
}

export const FilesForm = ({useFetchInit}) => {
    
    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        //------------- Formularios
        Forms,
        //------------- FetchData
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    const { formOpeningMode } = globalStates

    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    const { FormFiles } = Forms
    const { onDropZoneAcceptedFilesChange, onDropZoneRejectionsFilesChange,formState  } = FormFiles
    
    // ------------------------------------------------ FetchData
    
    // ------------------------------------------------ Actions
    const { handleClickCleanUpFiles, onSubmitFormFiles } = Actions


    return ( 
        <form onSubmit={onSubmitFormFiles}>
            <div className="text-center">
                <Button
                    startIcon= {<UploadCloud/>}
                    variant="contained"
                    type="submit"
                    style={{background: "#4b4b4c"}}
                    disabled={ (formOpeningMode === 'READONLY') ? true : false }
                >
                    Subir
                </Button>
                <Button
                    startIcon={<XCircle/>}
                    variant="contained"
                    type="button"
                    onClick={handleClickCleanUpFiles}
                    style={{background: "#ef8157"}}
                    disabled={ (formOpeningMode === 'READONLY') ? true : false }
                >
                    Limpiar
                </Button>
            </div>
            <FormControl fullWidth>
                <label htmlFor="attachmentt"> * Documentos para enviar a revisión </label>
                {formOpeningMode !== 'READONLY' && (
                    <FileManagerInput
                        // datos (listados, individuales)
                        acceptedFiles={formState.acceptedFiles}
                        fileRejections={formState.fileRejections}
                        NameId='attachmentt'
                        typeFiles='PDF'
                        maxFiles={4}
                        accept={acceptConfiguration}

                        // HandleClicks

                        // Funciones
                        setAcceptedFiles={onDropZoneAcceptedFilesChange}
                        setFileRejections={onDropZoneRejectionsFilesChange}
                    />
                )}
            </FormControl>
        </form>
    )
    
}